var render, staticRenderFns
import script from "./NgTable.vue?vue&type=script&lang=js&"
export * from "./NgTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e254187",
  null
  
)

export default component.exports